import ApiPermitOrders from "src/apis/permit_orders";
import React, { useEffect, useState } from "react";
import PermitOrderForm from "src/modules/permit/permit_order_form";
import useApiMessageHandler from "src/helpers/useApiMessageHandler";

const PermitOrderFormWrapper = () => {
  const [allowed, setAllowed] = useState(false);
  const [checking, setChecking] = useState(true);
  const { checkDivisionAccess } = ApiPermitOrders();
  const { catchErrorsController, backendMessagesController } =
    useApiMessageHandler();

  useEffect(() => {
    checkDivisionAccess()
      .then((response) => {
        let data = response.data;
        backendMessagesController([data]);
        if (Number(response.data.status) === 1) {
          setAllowed(true);
        }
      })
      .catch((errors) => {
        catchErrorsController("Load Order Form", errors);
      })
      .finally(() => {
        setChecking(false);
      });
  }, []);

  if (checking) {
    return <div></div>;
  }

  return allowed ? (
    <PermitOrderForm />
  ) : (
    <div>
      <h1 className="text-center ">Permit Order Form</h1>
    </div>
  );
};

export default PermitOrderFormWrapper;
